import { useNavigate } from "react-router-dom";

import NoDataModule from "@/components/shared/ui/NoDataModule/NoDataModule";
import { getPressIdFromURL } from "@utils/getStateFromURL";

const ClassificationNotDefined = () => {
  const navigate = useNavigate();
  const articleId = getPressIdFromURL();

  return (
    <NoDataModule
      message={`${
        articleId ? `(#${articleId}) ` : ""
      }There is no classification data to fill in this article.`}
      buttonLabel="Back to List"
      onButtonClick={() => navigate(-1)}
    />
  );
};

export default ClassificationNotDefined;
